"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.VISITOR_SEGMENT = exports.USE_PRODUCT_DATA_CACHING = exports.USE_PRODUCTS_SERVICE = exports.TENANT_CONTEXT = exports.REGISTRATION_ID = exports.PREVIEW_MODE = exports.PLACEMENT = exports.CUSTOMER_TYPE_ID = exports.CUSTOMER_CONTEXT = exports.CONTENT_TYPE = exports.CLIENT_APPLICATION = exports.CHANNEL_TYPE = exports.AUTHORIZATION = exports.ATP_CLUSTER_ID = exports.ACCEPT_LANGUAGE = void 0;
var ACCEPT_LANGUAGE = exports.ACCEPT_LANGUAGE = 'accept-language';
var ATP_CLUSTER_ID = exports.ATP_CLUSTER_ID = 'x-atp-cluster-id';
var AUTHORIZATION = exports.AUTHORIZATION = 'authorization';
var CHANNEL_TYPE = exports.CHANNEL_TYPE = 'x-client-channel';
var CLIENT_APPLICATION = exports.CLIENT_APPLICATION = 'x-client-application';
var CONTENT_TYPE = exports.CONTENT_TYPE = 'content-type';
var CUSTOMER_CONTEXT = exports.CUSTOMER_CONTEXT = 'x-customer-context';
var CUSTOMER_TYPE_ID = exports.CUSTOMER_TYPE_ID = 'x-customer-type-id';
var PLACEMENT = exports.PLACEMENT = 'x-placement';
var PREVIEW_MODE = exports.PREVIEW_MODE = 'x-preview-mode';
var REGISTRATION_ID = exports.REGISTRATION_ID = 'x-registration-id';
var TENANT_CONTEXT = exports.TENANT_CONTEXT = 'x-tenant-context';
var USE_PRODUCT_DATA_CACHING = exports.USE_PRODUCT_DATA_CACHING = 'x-use-product-data-caching';
var USE_PRODUCTS_SERVICE = exports.USE_PRODUCTS_SERVICE = 'x-use-products-service';
var VISITOR_SEGMENT = exports.VISITOR_SEGMENT = 'x-visitor-segment'; //# sourceMappingURL=headers.js.map
